import { render } from "./RezervationValueForm.vue?vue&type=template&id=e78e9f82"
import script from "./RezervationValueForm.vue?vue&type=script&lang=js"
export * from "./RezervationValueForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__